<div class="main-content">
  <!-- Admin Wallet Section -->
  <div class="admin-wallet-container" *ngIf="adminWallet">
    <div class="admin-wallet-card">
      <div class="wallet-header">
        <div class="user-name">Hygge</div>
        <!-- <div class="user-id">ID: {{ adminWallet.user_id }}</div> -->
      </div>

      <div class="balance-section">
        <div class="balance-item">
          <div class="balance-label">Bank Balance</div>
          <div class="balance-amount">
            {{ formatNumber(adminWallet.bank_balance) }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Blockchain Hashes Section (Bid Round Level) -->
  <div
    class="bid-round-hashes-section"
    *ngIf="blockchainHashes?.items?.length > 0"
  >
    <div class="token-title">Block Chain Hashes</div>
    <div *ngIf="blockchainHashesLoading" class="loading-contracts">
      Loading blockchain hashes...
    </div>
    <div *ngIf="blockchainHashesError" class="error-message">
      {{ blockchainHashesError }}
    </div>
    <div class="contracts-list">
      <div *ngFor="let hash of blockchainHashes.items" class="contract-item">
        <div class="contract-details">
          <span class="contract-amount">
            <a
              href="javascript:void(0)"
              (click)="showHashDetails(hash)"
              class="text-primary"
            >
              {{ hash.hash_type }}: {{ hash.hash_value | slice : 0 : 10 }}...{{
                hash.hash_value | slice : -10
              }}
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="bid-round-id-container">
    <div class="bid-round-id-label">Bid Round ID (UUID)</div>
    <input
      type="text"
      [(ngModel)]="bidRoundId"
      placeholder="Enter UUID without quotes"
      class="bid-round-id-input"
    />
  </div>
  <div class="search-container">
    <div class="search-inputs">
      <div
        *ngFor="let name of searchNames; let i = index"
        class="name-input-container"
      >
        <input
          *ngIf="name.toLowerCase() !== 'admin'"
          type="text"
          [(ngModel)]="searchNames[i]"
          placeholder="Name {{ i + 1 }}"
        />
        <button
          *ngIf="name.toLowerCase() !== 'admin'"
          class="remove-button"
          (click)="removeName(i)"
        >
          X
        </button>
      </div>
      <div class="add-name-container">
        <input
          type="text"
          [(ngModel)]="newName"
          placeholder="Add new name"
          (keyup.enter)="addName()"
        />
        <button class="add-button" (click)="addName()">+</button>
      </div>
    </div>
    <button class="update-button" (click)="fetchWalletData()">Update</button>
  </div>

  <div *ngIf="loading" class="loading">Loading wallet information...</div>

  <div *ngIf="error" class="error-message">
    {{ error }}
  </div>

  <div class="wallets-grid" *ngIf="!loading && !error">
    <div class="wallet-card" *ngFor="let wallet of wallets">
      <div class="wallet-header">
        <div class="user-name-container">
          <div
            class="user-name"
            [class.consumer]="wallet.user_role === 'Consumer'"
            [class.prosumer]="wallet.user_role === 'Prosumer'"
          >
            {{ wallet.user_name }}
          </div>
          <div class="user-id">ID: {{ wallet.user_id }}</div>
        </div>
      </div>

      <div class="balance-section">
        <div class="balance-item">
          <div class="balance-label">Bank Balance</div>
          <div class="balance-amount">
            {{ formatNumber(wallet.bank_balance) }}
          </div>
        </div>

        <div class="balance-item">
          <div class="balance-label">Hold</div>
          <div class="balance-amount frozen-amount">
            {{ formatNumber(wallet.bank_frozen) }}
          </div>
        </div>
      </div>

      <div class="smart-contract-section">
        <div class="smart-title">Smart Contract</div>
        <div class="balance-section">
          <div class="balance-item">
            <div class="balance-label">Available Balance</div>
            <div
              class="balance-amount"
              *ngIf="!availableBalanceLoading[wallet.user_id]"
            >
              {{ formatNumber(availableBalances[wallet.user_id] || 0) }}
            </div>
            <div
              class="balance-amount"
              *ngIf="availableBalanceLoading[wallet.user_id]"
            >
              <div
                class="spinner"
                style="
                  width: 20px;
                  height: 20px;
                  border: 2px solid #f3f3f3;
                  border-top: 2px solid #3498db;
                  border-radius: 50%;
                  animation: spin 1s linear infinite;
                "
              ></div>
            </div>
          </div>

          <div class="balance-item">
            <div class="balance-label">Reserved for Bids</div>
            <div class="balance-amount">
              {{ formatNumber(wallet.smart_contract_reserved_for_bids) }}
            </div>
          </div>

          <div class="balance-actions">
            <button
              class="encash-button"
              (click)="encashTokens(wallet.user_id)"
            >
              Encash Tokens
            </button>
          </div>
        </div>
      </div>

      <!-- Token Details Section -->
      <div
        class="token-details-section"
        *ngIf="
          tokenDetails[wallet.user_id]?.length > 0 &&
          !tokenContracts[wallet.user_id]?.length
        "
      >
        <div class="token-title">Token Details</div>

        <div
          *ngIf="tokenDetailsLoading[wallet.user_id]"
          class="loading-contracts"
        >
          Loading token details...
        </div>

        <div
          *ngIf="
            tokenDetails[wallet.user_id] &&
            tokenDetails[wallet.user_id].length > 0
          "
        >
          <!-- BID_AMOUNT Details -->
          <div
            *ngIf="
              getTokenDetailsByChargeType(wallet.user_id, 'BID_AMOUNT').length >
              0
            "
            class="contract-type-section"
          >
            <div class="contract-type-title">Bid Amount</div>
            <div class="contracts-list">
              <div
                *ngFor="
                  let token of getTokenDetailsByChargeType(
                    wallet.user_id,
                    'BID_AMOUNT'
                  )
                "
                class="token-item"
              >
                <div class="token-details">
                  <span class="token-amount"
                    >Amount: {{ formatNumber(+token.amount) }}</span
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- TRANSACTION_FEE Details -->
          <div
            *ngIf="
              getTokenDetailsByChargeType(wallet.user_id, 'TRANSACTION_FEE')
                .length > 0
            "
            class="contract-type-section"
          >
            <div class="contract-type-title">Transaction Fee</div>
            <div class="contracts-list">
              <div
                *ngFor="
                  let token of getTokenDetailsByChargeType(
                    wallet.user_id,
                    'TRANSACTION_FEE'
                  )
                "
                class="token-item"
              >
                <div class="token-details">
                  <span class="token-amount"
                    >Amount: {{ formatNumber(+token.amount) }}</span
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- PENALTY_HOLD Details -->
          <div
            *ngIf="
              getTokenDetailsByChargeType(wallet.user_id, 'PENALTY_HOLD')
                .length > 0
            "
            class="contract-type-section"
          >
            <div class="contract-type-title">Collateral</div>
            <div class="contracts-list">
              <div
                *ngFor="
                  let token of getTokenDetailsByChargeType(
                    wallet.user_id,
                    'PENALTY_HOLD'
                  )
                "
                class="token-item"
              >
                <div class="token-details">
                  <span class="token-amount"
                    >Amount: {{ formatNumber(+token.amount) }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Token Contracts Section -->
      <div
        class="token-contracts-section"
        *ngIf="tokenContracts[wallet.user_id]?.length > 0"
      >
        <div class="token-title">Token Contracts</div>

        <div
          *ngIf="tokenContractsLoading[wallet.user_id]"
          class="loading-contracts"
        >
          Loading token contracts...
        </div>

        <!-- BID_AMOUNT Contracts -->
        <div
          *ngIf="getContractsByType(wallet.user_id, 'BID_AMOUNT').length > 0"
          class="contract-type-section"
        >
          <div class="contract-type-title">Bid Amount</div>
          <div class="contracts-list">
            <div
              *ngFor="
                let contract of getContractsByType(wallet.user_id, 'BID_AMOUNT')
              "
              class="contract-item"
            >
              <div class="contract-details">
                <span class="contract-amount"
                  >Amount: {{ formatNumber(+contract.amount) }}</span
                >
                <span class="contract-status"
                  >Status: {{ contract.status }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- TRANSACTION_FEE Contracts -->
        <div
          *ngIf="
            getContractsByType(wallet.user_id, 'TRANSACTION_FEE').length > 0
          "
          class="contract-type-section"
        >
          <div class="contract-type-title">Transaction Fee</div>
          <div class="contracts-list">
            <div
              *ngFor="
                let contract of getContractsByType(
                  wallet.user_id,
                  'TRANSACTION_FEE'
                )
              "
              class="contract-item"
            >
              <div class="contract-details">
                <span class="contract-amount"
                  >Amount: {{ formatNumber(+contract.amount) }}</span
                >
                <span class="contract-status"
                  >Status: {{ contract.status }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- PENALTY_HOLD Contracts -->
        <div
          *ngIf="getContractsByType(wallet.user_id, 'PENALTY_HOLD').length > 0"
          class="contract-type-section"
        >
          <div class="contract-type-title">Collateral</div>
          <div class="contracts-list">
            <div
              *ngFor="
                let contract of getContractsByType(
                  wallet.user_id,
                  'PENALTY_HOLD'
                )
              "
              class="contract-item"
            >
              <div class="contract-details">
                <span class="contract-amount"
                  >Amount: {{ formatNumber(+contract.amount) }}</span
                >
                <span class="contract-status"
                  >Status: {{ contract.status }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Other Contract Types -->
        <div *ngFor="let type of ['OTHER']">
          <div
            *ngIf="getContractsByType(wallet.user_id, type).length > 0"
            class="contract-type-section"
          >
            <div class="contract-type-title">{{ type }}</div>
            <div class="contracts-list">
              <div
                *ngFor="
                  let contract of getContractsByType(wallet.user_id, type)
                "
                class="contract-item"
              >
                <div class="contract-details">
                  <span class="contract-amount"
                    >Amount: {{ formatNumber(+contract.amount) }}</span
                  >
                  <span class="contract-status"
                    >Status: {{ contract.status }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="note" *ngIf="!loading && !error && wallets.length === 0">
    No results found
  </div>
</div>
